import type { User } from '../types/auth';

/** An SSO user with neither an individual subscription nor a seat: the user of the blocked screen. */
export const isSsoAccessBlocked = (
  user: Pick<User, 'sso_provider' | 'individual_subscription_id' | 'current_seat_id'>,
): boolean => !!user.sso_provider && !user.individual_subscription_id && !user.current_seat_id;
